import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: theme.spacing(2.5),
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
  },
  cardEnrolled: {
    borderColor: '#4caf50',
    backgroundColor: '#f9fff9',
  },
  cardRequired: {
    borderColor: '#FF4500',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  topRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  iconAndTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    minWidth: 0,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#f5f5f5',
    color: '#FF4500',
  },
  iconEnrolled: {
    backgroundColor: '#e8f5e9',
    color: '#4caf50',
  },
  title: {
    fontWeight: 600,
    fontSize: '16px',
    marginBottom: theme.spacing(0.5),
  },
  description: {
    color: '#666',
    fontSize: '14px',
    wordBreak: 'break-word',
  },
  badges: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  requiredChip: {
    backgroundColor: '#FF4500',
    color: '#fff',
    fontWeight: 600,
    fontSize: '12px',
  },
  optionalChip: {
    backgroundColor: '#f5f5f5',
    color: '#666',
    fontSize: '12px',
  },
  enrolledChip: {
    backgroundColor: '#e8f5e9',
    color: '#4caf50',
    fontWeight: 600,
    fontSize: '12px',
  },
  inputContainer: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    borderTop: '1px solid #e0e0e0',
  },
  phoneInput: {
    '& .PhoneInput': {
      width: '100%',
      maxWidth: '300px',
      height: '40px',
      padding: '9px',
      border: '1px solid #777',
    },
    '& .PhoneInput:hover': {
      border: '1px solid #222',
      borderRadius: '0px',
    },
    '& .PhoneInput:focus-within': {
      border: '1px solid #ff4500',
    },
    '& .PhoneInputCountryIcon': {
      backgroundColor: 'none',
      boxShadow: 'unset',
      border: '0.5px solid #2223',
    },
    '& input': {
      fontSize: '16px',
      outline: 'none',
      border: 'none',
      width: '100%',
    },
  },
  inputLabel: {
    color: '#2E343B',
    fontSize: '14px',
    lineHeight: '24px',
    marginBottom: theme.spacing(0.5),
    fontWeight: 500,
  },
  emailInput: {
    maxWidth: '300px',
  },
  enrollButton: {
    marginTop: theme.spacing(2),
  },
  otpContainer: {
    marginTop: theme.spacing(2),
    '& .otp-input-container': {
      display: 'flex',
      gap: '8px',
      justifyContent: 'flex-start',
    },
    '& .otp-input': {
      width: '40px !important',
      height: '48px',
      fontSize: '18px',
      borderRadius: '4px',
      border: '1px solid #ccc',
      textAlign: 'center',
      '&:focus': {
        borderColor: '#FF4500',
        outline: 'none',
      },
    },
    '& .otp-input--focused': {
      borderColor: '#FF4500',
    },
  },
  verifyButton: {
    marginTop: theme.spacing(2),
  },
  successIcon: {
    color: '#4caf50',
    marginLeft: theme.spacing(1),
  },
  enrolledInfo: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    color: '#4caf50',
    fontSize: '14px',
  },
  errorText: {
    color: '#d32f2f',
    fontSize: '14px',
    marginTop: theme.spacing(1),
  },
  resendContainer: {
    marginTop: theme.spacing(1.5),
    minHeight: '24px',
  },
  resendLink: {
    color: '#FF4500',
    cursor: 'pointer',
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  resendDisabled: {
    color: '#999',
    cursor: 'default',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  resendSuccess: {
    color: '#4caf50',
    fontSize: '14px',
    fontWeight: 500,
  },
}))

export default useStyles
